export interface ITerraceInputs {
    readonly label?: string,
    readonly inputType: 'text' | 'number' | 'dropdown' | 'radio' | 'title',
    className: string,
    options?: any;
    readonly?: boolean;
    errorCode?:string;
    required?:boolean;
    min?: number;
    max?: number
    decimalPlaces?: number;
    disabled?: boolean;
    hidden?: boolean;
}

export interface IInputForms {
    TerraceInfoSection: {
        terraceName: string;
        terraceType: number | '';
        terraceBenchmark: string;
        constructionBenchmark: string;
        benchmarkElevation: number;
        benchmarkDescription: string;
    };
    AlignmentSection: {
        alignment: number | '',
        strippingDepth: number | ''
    };
    HydrologySection: {
        subbasin: string,
        frequency: number | '',
        hydrograph: string,
        drainageArea: number| '',
        curvNumber: number | '',
        watershedLength: number | '',
        watershedSlope: number | '',
    };
    SoilStrengthSection: {
        erodibility: string;
    };
    // VegetalCoverSection: {
    //     vegetalCoverType: string,
    //     vegetalCoverDescription: string;
    //     vegetalCoverManualValue: string;
    // };
    StorageSection: {
        designLife: number | string,
        floodRoutingModel: string,
        percentageStored: number | string,
        erosionRate: number | string,
        trapEfficiency: number | string,
        sedimentDensity: number | string,
        floodDuration: number | string
    };
}

export interface ISubbasinCalculationResult {
    basinName: string; 
    dimUnitHydrog: string; // Example: "Standard-484"
    dimUnitHydrogID: number; 
    fileName: string;
    frequency: number; 
    fullHydroModel: boolean; 
    latLongInfo: string; 
    peakFlow: number; 
    precipitation: number; 
    qu: number; 
    rainfallCellID: number; 
    runoffQ: number; 
    timeOfConcentrate: number; 
    totalRunOff: number; 
    watershedArea: number; 
    watershedCN: number; 
    watershedLength: number; 
    watershedSlope: number; 
}

export const hydrologyFrequencyOptions = [
    {
        name: '1 year',
        value: 1,
    },
    {
        name: '2 year',
        value: 2,
    },
    {
        name: '5 year',
        value: 5,
    },
    {
        name: '10 year',
        value: 10,
    },
    {
        name: '25 year',
        value: 25,
    },
    {
        name: '50 year',
        value: 50,
    },
    {
        name: '100 year',
        value: 100,
    },
]
export const floodDurationOptions = [
    {
        name: '6',
        value: '6',
    },
    {
        name: '9',
        value: '9',
    },
    {
        name: '12',
        value: '12',
    },
    {
        name: '15',
        value: '15',
    },
    {
        name: '18',
        value: '18',
    },
    {
        name: '21',
        value: '21',
    },
    {
        name: '24',
        value: '24',
    },
    {
        name: '30',
        value: '30',
    },
    {
        name: '36',
        value: '36',
    },
    {
        name: '48',
        value: '48',
    },
    {
        name: '60',
        value: '60'
    },
    {
        name: '72',
        value: '72'
    }
]

export const vegetalCoverTypeOptions = [
    {
        name: 'User Defined',
        value: 'User Defined',
    },
    {
        name: 'None Bare (0)',
        value: 'None Bare (0)',
    },
    {
        name: 'Alfalfa (0.5)',
        value: 'Alfalfa (0.5)',
    },
    {
        name: 'Bunch Grasses(Love Grass) (0.5)',
        value: 'Bunch Grasses(Love Grass) (0.5)',
    },
    {
        name: 'Common Lespedeza (0.5)',
        value: 'Common Lespedeza (0.5)',
    },
    {
        name: 'Crabgrass (0.5)',
        value: 'Crabgrass (0.5)',
    },
    {
        name: 'Lespedeza Sericea (0.5)',
        value: 'Lespedeza Sericea (0.5)',
    },
    {
        name: 'Redfescue (0.5)',
        value: 'Redfescue (0.5)',
    },
    {
        name: 'Redtop (0.5)',
        value: 'Redtop (0.5)',
    },
    {
        name: 'Sudangrass (0.5)',
        value: 'Sudangrass (0.5)',
    },
    {
        name: 'Weeping Lovegrass (0.5)',
        value: 'Weeping Lovegrass (0.5)',
    },
    {
        name: 'Yellow Bluestem (0.5)',
        value: 'Yellow Bluestem (0.5)',
    },
    {
        name: 'Grass Mixture (0.75)',
        value: 'Grass Mixture (0.75)',
    },
    {
        name: 'Mixed Grasses (Native Grass) (0.75)',
        value: 'Mixed Grasses (Native Grass) (0.75)',
    },
    {
        name: 'Reed Canarygrass (0.75)',
        value: 'Reed Canarygrass (0.75)',
    },
    {
        name: 'Bahiagrass (0.87)',
        value: 'Bahiagrass (0.87)',
    },
    {
        name: 'Blue Grama (0.87)',
        value: 'Blue Grama (0.87)',
    },
    {
        name: 'Buffalograss (0.87)',
        value: 'Buffalograss (0.87)',
    },
    {
        name: 'Kentucky Bluegrass (0.87)',
        value: 'Kentucky Bluegrass (0.87)',
    },
    {
        name: 'Smooth Brome (0.87)',
        value: 'Smooth Brome (0.87)',
    },
    {
        name: 'Tall Fescue (0.87)',
        value: 'Tall Fescue (0.87)',
    },
    {
        name: 'Turf Grass (Bufflo Grass) (0.87)',
        value: 'Turf Grass (Bufflo Grass) (0.87)',
    },
    {
        name: 'Bermudagrass (0.9)',
        value: 'Bermudagrass (0.9)',
    },
    {
        name: 'Centipedgrass (0.9)',
        value: 'Centipedgrass (0.9)',
    }

]


export const terraceTypeOptions = [
    {
        name: 'Gradient',
        value: '20',
    },
    {
        name: 'Level',
        value: '21',
    },
    {
        name: 'Storage',
        value: '22',
    },
    {
        name: 'Wascob',
        value: '23',
    }
]
export const subbasinRunoffProps: IResultsContainerProps = {
    rowCols: 1,
    extraClass: "custom-class",
    resultGroups: [
        {
            title: "Subbasin Runoff",
            key: 'subbasinRunoff',
            items: [
                { label: "Runoff Q (in)", key: 'runoffQ' },
                { label: "Peak Flow Q (cfs)", key: 'peakFlow' },
                { label: "Total Runoff (ac-in)", key: 'totalRunOff' },
            ],
        },
    ],
};

export const storageProps: IResultsContainerProps = {
    rowCols: 3,
    extraClass: "custom-class",
    resultGroups: [
        {
            title: "Sediment Storage",
            key: 'sedimentStorage',
            items: [
                { label: "Sediment Storage (ac-in)", key: 'sedimentStorage' },
                { label: "Runoff Depth (in)", key: 'equivalentRunoffDepthForSediment' },
            ],
        },
        {
            title: "Runoff Storage",
            key: 'runoffStorage',
            items: [
                { label: "Runoff Storage (ac-in)", key: 'runoffStorage' },
                { label: "Runoff Depth (in)", key: 'equivalentRunoffDepthForRunoff' },
                { label: "Required Discharge (cfs)", key: 'requiredDischarge' },
            ],
        },
        {
            title: "Model",
            key: 'model',
            items: [
                { label: "Erosion Model", key: 'model' },
            ],
        },
    ],
};

export const erodibleOption: {name: string, value: any}[] = []; 
export const vegCoverOption: {name: string, value: any}[] = []; 
interface ResultItem {
    readonly label: string;
    readonly key: string;
}

interface ResultGroup {
    readonly title: string;
    readonly key: string;
    readonly items: readonly ResultItem[];
}

export interface IResultsContainerProps {
    readonly rowCols: number;
    readonly extraClass: string;
    readonly resultGroups: readonly ResultGroup[];
}

// modified <ResultsContainer> from Formula

export const TerraceInputsConfig: Record<string, Record<string, ITerraceInputs>> = {
    TerraceInfoSection: {
        terraceName: {
            label: 'Terrace Name',
            inputType: 'text',
            className: 'terraceName',
             errorCode: 'Common_17'
        },
        terraceType: {
            label: 'Terrace Type',
            inputType: 'dropdown',
            options: terraceTypeOptions,
            className: 'terraceType',
            errorCode: 'Common_17'
        },
        terraceBenchmark: {
            label: 'Terrace Benchmark (Optional)',
            inputType: 'title',
            className: 'terraceBenchmark',
            
        },
        constructionBenchmark: {
            label: 'Construction Benchmark',
            inputType: 'text',
            className: 'constructionBenchmark',
            required: false,
        },
        benchmarkElevation: {
            label: 'Benchmark Elevation (ft)',
            inputType: 'number',
            className: 'benchmarkElevation',
            required: false,
        },
        benchmarkDescription: {
            label: 'Benchmark Description',
            inputType: 'text',
            className: 'benchmarkDescription',
            required: false,
        }
    },

    AlignmentSection: {
        alignment: {
            label: 'Alignment',
            className: 'alignment',
            inputType: 'dropdown',
            options:[],
            errorCode: 'Common_17'
        },
        strippingDepth: {
            label: 'Stripping Depth (in)',
            className: 'strippingDepth',
            inputType: 'number',
            required: false,
        }
    },

    HydrologySection: {
        stormRunoff: {
            label: 'Storm Runoff',
            inputType: 'title',
            className: 'storm-runof'
        },
        subbasin: {
            label: 'Subbasin',
            inputType: 'dropdown',
            options: [{ name: 'Hydro_Tool', value: 'Hydro_Tool' }],
            className: 'subbasin',
            errorCode: 'Common_17'
        },
        frequency: {
            label: 'Frequency',
            className: 'frequency',
            inputType: 'dropdown',
            options: hydrologyFrequencyOptions,
            errorCode: 'Common_17'
        },
        hydrograph: {
            label: 'Dimensionless Unit Hydrograph',
            className: 'hydrograph',
            inputType: 'text',
            readonly: true,
            errorCode: 'Common_17'
        },
        drainageArea: {
            label: 'Drainage Area (ac)',
            inputType: 'number',
            className: 'drainageArea',
            errorCode: 'Common_10',
            min:0.01
        },
        curvNumber: {
            label: 'Curve Number',
            inputType: 'number',
            className: 'curvNumber',
            min:30,
            max:100,
            errorCode: 'Hydro_48',
            decimalPlaces:0
        },
        watershedLength: {
            label: 'Watershed Length (ft)',
            inputType: 'number',
            className: 'watershedLength',
            min:200,
            max: 26000,
            errorCode: 'Hydro_14',
            decimalPlaces:0
        },
        watershedSlope: {
            label: 'Watershed Slope (%)',
            inputType: 'number',
            className: 'watershedSlope',
            errorCode: 'Common_10',
            min:0.01,
        },
    },

    SoilStrengthSection: {
        erodibility: {
            label: 'Erodibility',
            inputType: 'dropdown',
            options: erodibleOption, 
            className: 'erodibility',
            errorCode: 'Common_17',
        }
    },

    VegetalCoverSection: {
        vegetalCoverType: {
            label: 'Select a Vegetal Cover Type',
            inputType: 'dropdown',
            options: vegetalCoverTypeOptions, 
            className: 'vegetalCoverType',
            errorCode: 'Common_17',
        },
        vegetalCoverDescription: {
            label: 'Or Manually Enter Vegetal Cover Type Description',
            inputType: 'text',
            className: 'vegetalCoverDescription',
            errorCode: 'Common_17',
        },
        vegetalCoverManualValue: {
            label: 'Enter a Numeric Value',
            inputType: 'number',
            className: 'vegetalCoverManualValue',
            errorCode: 'Common_10',
            min: 0.01
        }
    },

    StorageSection: {
        floodRoutingModel: {
            label: 'Flood Routing Model',
            inputType: 'dropdown',
            options: [{name: 'Caldwell Method', value: 'CaldwellModel'},{ name: 'Percent Stored', value: 'PercentageStored' }, {name: 'Standard Flood Routing', value: 'StandardFloodRouting'}],
            className: 'floodRoutingModel',
            errorCode: 'Common_17' // 'Common_10',
        },
        percentageStored: {
            label: 'Percentage Stored (%)',
            inputType: 'number',
            className: 'percentageStored',
            min: 0,
            max:100,
            errorCode: 'Terrace_9',
            hidden: false,
        },
        floodDuration: {
            label: 'Flood Duration (hr)',
            inputType: 'dropdown',
            className: 'floodDuration',
            options:floodDurationOptions,
            errorCode: 'Terrace_10',
        },
        designLife: {
            label: 'Design Life (yr)',
            inputType: 'number',
            //options: [{ name: 10, value: 10 }],
            className: 'designLife',
            errorCode: 'Terrace_5',
            decimalPlaces: 0,
            min: 1,
            max: 10,
        },
        erosionRate: {
            label: 'Erosion Rate (T/ac-yr)',
            inputType: 'number',
            className: 'erosionRate',
            min: 0.01,
            errorCode: 'Common_10',

        },
        trapEfficiency: {
            label: 'Trap Efficiency',
            inputType: 'number',
            className: 'trapEfficiency',
            min: 0,
            max:1,
            errorCode: 'Terrace_12',
        },
        sedimentDensity: {
            label: 'Sediment Density (T/cy)',
            inputType: 'number',
            className: 'sedimentDensity',
            min: 0.47,
            max:1.5,
            errorCode: 'Terrace_13',
        }
    }
};
